import styled, { css } from 'styled-components';
import { AssistiveTechnologyOnly } from '../../styles/AssistiveTechnologyOnly';
import { theme, variables } from '../themes/theme';
export const StyledLabel = styled.label `
  color: ${variables.Gray};
  display: block;
  font-family: ${props => props.theme.fonts.serif};
  font-size: 0.8125rem;
  line-height: 1.38;
  margin-bottom: 0.1875rem;
  text-align: left;

  ${(props) => props.isLabelHidden &&
    css `
      ${AssistiveTechnologyOnly}
    `}

  ${(props) => props.isInvalid &&
    css `
      color: ${theme.BrandPrimary};
    `};
`;
